export default function HowProjectGoes() {
  const steps = [
    { icon: 'ri-shake-hands-line', title: 'Знакомство', desc: 'Обсуждаем задачи бизнеса, определяем цели обучения, формируем ожидания от программы.' },
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Анализ переговорной практики: типы переговоров, частые сценарии, слабые места, уровень команды.' },
    { icon: 'ri-file-settings-line', title: 'Подготовка', desc: 'Адаптация программы под специфику компании, подготовка кейсов из реальной практики участников.' },
    { icon: 'ri-presentation-line', title: 'Обучение', desc: 'Практический тренинг: переговорные поединки, ролевые игры, разбор техник и инструментов.' },
    { icon: 'ri-sword-line', title: 'Практика', desc: 'Отработка навыков на реальных переговорах. Домашние задания и подготовка к предстоящим встречам.' },
    { icon: 'ri-refresh-line', title: 'Сопровождение', desc: 'Поддержка после тренинга: разбор переговоров, корректировка стратегии, ответы на вопросы.' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Оценка результатов', desc: 'Измерение KPI: конверсия, средний чек, маржинальность. Сравнение с исходными показателями.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Как проходит проект <strong>тренинга по переговорам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Семь последовательных шагов — от знакомства до оценки результатов. Каждый этап логически продолжает предыдущий.
          </p>
        </div>

        <div className="relative">
          {steps.map((step, i) => (
            <div key={i} className="flex items-start gap-5 mb-0">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                  {i + 1}
                </div>
                {i < steps.length - 1 && (
                  <div className="w-0.5 h-16 bg-teal-200"></div>
                )}
              </div>
              <div className="pb-8 pt-3">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-sm text-teal-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed ml-11">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}